import * as React from 'react';
import cx from 'classnames';
import { runSync } from '@mdx-js/mdx';

import { components } from './compiler';

import * as cs from './Markdown.module.css';

let jsxRuntime: any;
if (process.env.NODE_ENV === 'development') {
  jsxRuntime = require('react/jsx-dev-runtime');
} else {
  jsxRuntime = require('react/jsx-runtime');
}

interface Props {
  body: string;
  className?: string;
  customComponents?: Record<string, (props: any) => React.JSX.Element>;
}

export const Markdown = ({
  body,
  className,
  customComponents,
  ...restProps
}: Props) => {
  const { default: Component } = React.useMemo(
    () => runSync(body, { ...jsxRuntime }),
    [body],
  );

  const mdxComponents = React.useMemo(() => {
    return { ...components, ...customComponents };
  }, [customComponents]);

  return (
    <div className={cx(cs.root, className)} {...restProps}>
      <Component components={mdxComponents} />
    </div>
  );
};
